import React from 'react';

interface ChannelListProps {
  channels: string[];
  selectedChannel: string;
  onSelectChannel: (channel: string) => void;
  channelCounts?: Record<string, number>;
}

const ChannelList: React.FC<ChannelListProps> = ({
  channels,
  selectedChannel,
  onSelectChannel,
  channelCounts = {},
}) => {
  if (!channels.length) {
    return (
      <div className="compliance-player__channels">
        <div className="compliance-player__channel-list is-empty">No channels found.</div>
      </div>
    );
  }

  return (
    <div className="compliance-player__channels">
      <div className="compliance-player__channel-list">
        {channels.map((channel) => {
          const isSelected = channel === selectedChannel;
          const count = channelCounts[channel] ?? 0;
          return (
            <button
              key={channel}
              className={`compliance-player__channel${isSelected ? ' is-selected' : ''}`}
              onClick={() => onSelectChannel(channel)}
              aria-pressed={isSelected}
            >
              <span className="compliance-player__channel-name">{channel}</span>
              <span className="compliance-player__channel-count">{count}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ChannelList;
